import { TableUIProvider } from "../../../contexts/TableUIContext";
import ExpenseTypes from "./ExpenseTypes";

export default function ExpenseTypesWrapper() {
    return (
        <TableUIProvider>
            <ExpenseTypes />
        </TableUIProvider>
    );
}
